import React, { FC, memo } from "react";

import { Button, IButtonProps } from "../../../Button";
import { OpenableWrapper } from "../../OpenableWrapper";
import { IOpenable } from "../../types";

export interface IOpenableButtonProps extends IButtonProps {
  openable: React.ComponentType<IOpenable>;
  openableProps?: any;
}

export const OpenableButton: FC<IOpenableButtonProps> = memo(
  ({ openable: Openable, openableProps, ...buttonProps }) => {
    return (
      <OpenableWrapper>
        {({ hideOpenable, open, showOpenable }) => (
          <>
            <Button {...buttonProps} onClick={showOpenable} />
            <Openable open={open} onClose={hideOpenable} {...openableProps} />
          </>
        )}
      </OpenableWrapper>
    );
  },
);
